import React, { useCallback } from 'react'
import '../../styles/Auth.css'
import { getLanguageSelector } from '../../selectors'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import config from 'custom/config/environment'
import { setAppLanguage } from '../../actions'
import i18next from 'i18next'
import { AUTH_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'

export default function AuthStaticLayout({ children }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const selectedLng = useSelector(getLanguageSelector)

  let pathExist = []
  let path = ''

  const handleLanguage = useCallback((e) => {
    try {
      const { value } = e.target
      dispatch(setAppLanguage(value))
      i18next.changeLanguage(value)
    } catch (err) {}
  }, [])

  return (
    <div className='row auth-layout-section' style={{ overflow: 'auto' }}>
      <div className='col-xs-12 col-sm-5 col-md-5 col-xl-5 col-lg-5  ' style={{ height: '100vh' }}>
        {config.LANGUAGE_SELECTION && (
          <div className='language-selection'>
            <select onChange={handleLanguage} value={selectedLng} placeholder='Choose Language'>
              {config.LANGUAGE_LIST.map((option, index) => (
                <option value={option} key={index}>
                  {option.toLocaleUpperCase()}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className='auth-render-section h-100 d-flex flex-column'>
          <div className='text-center'>
            <div className='auth-logo'></div>
          </div>
          <div>{children}</div>

          <div></div>
        </div>
      </div>
      <div className='col-7 oval-static d-none d-sm-block d-md-block d-xl-block d-lg-block'>
        {/* <div className="slogan">
          <div className="title1">
            <h3>{t(AUTH_KEYS.GET_STARTED_KEYS.SLOGAN_1)}</h3>
            <h1 className="slogan_heading1">{t(AUTH_KEYS.GET_STARTED_KEYS.SLOGAN_2)}</h1>
          </div>
          <div className="title2" style={{marginLeft:140}}>
            <h3>{t(AUTH_KEYS.GET_STARTED_KEYS.SLOGAN_3)}</h3>
            <h1>{t(AUTH_KEYS.GET_STARTED_KEYS.SLOGAN_4)}</h1>
          </div>
        </div> */}
      </div>
    </div>
  )
}
